<template>
  <div class="create-material">
    <PageHeader title="Add Material" />

    <div class="shadow p-5 mt-2 mb-5 bg-white rounded">
      <MaterialForm
        :model="material"
        :save-function="createMaterial"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import PageHeader from '@/components/app/AppPageHeader.vue'
import { useHead } from '@unhead/vue'
import { Material } from '@/models/material'
import MaterialForm from '../components/MaterialForm.vue'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import MaterialService from '@/services/MaterialService'
import { useRouter } from 'vue-router'
import { useNotification } from '@kyvg/vue3-notification'

useHead({ title: 'Add Material' })

const material = ref(new Material())
const materialService = new MaterialService()
const $router = useRouter()
const { notify } = useNotification()
const queryClient = useQueryClient()

const { mutateAsync: createMaterial } = useMutation({
  mutationFn: (material: Material) => materialService.create(material),
  onSuccess: (createdMaterial: Material) => {
    notify({
      type: 'success',
      title: 'Material created',
      text: 'Material created successfully'
    })
    queryClient.setQueryData(['material', createdMaterial.id], createdMaterial)
    queryClient.invalidateQueries({ queryKey: ['materials'] })
    $router.push({ name: 'ListMaterials' })
  },
  onError: (error) => {
    notify({
      type: 'error',
      title: 'Error',
      text: error.message || 'An error occurred while trying to create the material'
    })
    console.error(error)
  }
})
</script>
